import { isNumber, isString } from 'lodash-es';
import type { MapboxIMap } from '..';

export const fitToBBox: MapboxIMap['fitToBBox'] = function (
  this: MapboxIMap,
  bbox,
  options = {}
) {
  const { padding = 50, maxZoom = 13 } = options;

  const { width, height } = this._native.getContainer().getBoundingClientRect();

  const adjustedPadding = (() => {
    if (isString(padding) && padding.endsWith('%')) {
      return Math.min(width, height) * (parseFloat(padding) / 100);
    }

    if (isNumber(padding)) return padding;
    return 0;
  })();

  /**
   * Mapbox computes a NaN camera and throws "Invalid LngLat object" when the
   * padding leaves no room for the bounds (e.g. the bottom table is dragged
   * all the way up). Fitting is pointless at that size, so we only center.
   */
  if (width <= adjustedPadding * 2 || height <= adjustedPadding * 2) {
    this._native.jumpTo({
      center: [(bbox[0] + bbox[2]) / 2, (bbox[1] + bbox[3]) / 2],
    });
    return;
  }

  this._native.fitBounds([bbox[0], bbox[1], bbox[2], bbox[3]], {
    padding: adjustedPadding,
    maxZoom,
    easing: () => 1,
  });
};
